import React from 'react';
import { ExtendedTheme, Heading, TextBlock, Children } from 'neon-design-system';
import { createStyles, makeStyles, Box, Hidden } from '@material-ui/core';

interface SectionHeaderProps {
	id?: string;
	title: string;
	subtitle?: React.ReactNode;
	isSmall?: boolean;
	headingToolbar?: Children;
	sectionHeaderOffsetDisabled?: boolean;
}

const useStyles = makeStyles<ExtendedTheme, SectionHeaderProps>((theme: ExtendedTheme) => createStyles({
	sectionHeaderContainer: {
		marginBottom: (props: SectionHeaderProps) => props.sectionHeaderOffsetDisabled ? 0 : theme.spacing(2)
	},
	sectionHeaderHeading: {
		marginBottom: (props: SectionHeaderProps) => props.subtitle ? theme.spacing(1) : 0
	}
}))

const SectionHeader = (props: SectionHeaderProps): JSX.Element => {
	const { title, subtitle, id, isSmall = false, headingToolbar } = props;
	const classes = useStyles(props);

	return (
		<div
			id={id}
			className={classes.sectionHeaderContainer}
		>
			<Box display="flex" justifyContent="space-between">
				<Heading styleName={isSmall ? 'headline1' : 'title1'} xs="small" md="medium" xl="large" className={classes.sectionHeaderHeading}>
					{title}
				</Heading>
				{
					headingToolbar && (
						<Hidden xsDown>
							{headingToolbar}
						</Hidden>
					)
				}
			</Box>
			{
				subtitle && (
					<TextBlock
						xs="small"
						md="medium"
						xl="large"
						ink="muted">
						{subtitle}
					</TextBlock>
				)
			}
			{
				headingToolbar && (
					<Hidden smUp>
						<Box mt={2}>
							{headingToolbar}
						</Box>
					</Hidden>
				)
			}
		</div>
	);
};

export default SectionHeader;
